import { createRouter, createWebHistory } from "vue-router"
import AuthMiddleware from "@/middleware/auth"
const Home = () => import(/* webpackChunkName: "routes" */ "@/views/Home")
const SignIn = () =>
  import(/* webpackChunkName: "routes" */ "@/views/auth/SignIn.vue")
const GlobalSearch = () =>
  import(/* webpackChunkName: "routes" */ "@/views/GlobalSearch")
const PrintRequisition = () => import("@/components/orders/PrintRequisition")
const PrintCaseRequisition = () => import("@/components/cases/PrintRequisition")

import { CaseRouter } from "@/router/casesRouter"

import { SendOutsRouter } from "@/router/sendOutsRouter"

import { HospitalRouter } from "@/router/hospitalRouter"

import { PhysicianRouter } from "@/router/physicianRouter"

import { OrdersRouter } from "@/router/ordersRouter"

import { UserAccountsRouter } from "@/router/userAccountsRouter"

import { InsurancesRouter } from "@/router/insurances"

import { RuleBookRouter } from "@/router/billingRuleBookRouter"

const LabDocumentFolders = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/labDocuments/LabDocumentFolders"
  )
const updatePassword = () =>
  import(/* webpackChunkName: "routes" */ "@/components/UpdatePassword.vue")
const SupplementaryReportView = () =>
  import(
    /* webpackChunkName: "routes" */ "@/views/cases/SupplementaryReportView"
  )
const TestReports = () =>
  import(/* webpackChunkName: "routes" */ "@/views/cases/TestReports")
import(
  /* webpackChunkName: "routes" */ "@/components/cases/HtmlUrineReportPreview"
)
const LabCategoryFiles = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/labDocuments/LabDocumentsFiles"
  )
const ErequisitionView = () => import("@/views/cases/ErequisitionView")
const ErequisitionViewOrders = () =>
  import("@/components/orders/ErequisitionViewOrders")
const Attachments = () => import("@/views/cases/Attachments")
const CommercialInsuranceSettings = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/commercialSettings/Settings"
  )
const CommercialInsuranceFacilitySettings = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/commercialSettings/FacilitySettings"
  )
const PotentialPayers = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/potentialPayers/PotentialPayers"
  )
  const icd10Codes = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/allIcd10Codes/Icd10Codes"
  )
const Exports = () =>
  import(/* webpackChunkName: "routes" */ "@/components/Exports")
const routes = [
  {
    path: "/",
    component: Home,
    children: [
      ...CaseRouter,
      ...OrdersRouter,
      ...UserAccountsRouter,
      ...SendOutsRouter,
      ...HospitalRouter,
      ...PhysicianRouter,
      ...InsurancesRouter,
      ...RuleBookRouter,
      {
        path: "/labs-documents",
        name: "LabDocumentFolders",
        component: LabDocumentFolders,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LAB DOCUMENTS",
        },
      },
      {
        path: "/labs-documents/:folder_id/:folder_name",
        name: "LabCategoryFiles",
        component: LabCategoryFiles,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "Lab Documents",
        },
      },
      {
        path: "/update-password",
        name: "updatePassword",
        component: updatePassword,
        meta: {
          title: "UPDATE PASSWORD",
        },
      },
      {
        path: "/global-search",
        name: "GlobalSearch",
        component: GlobalSearch,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "GLOBAL SEARCH",
        },
      },
      {
        path: "/all-report-download",
        name: "Exports",
        component: Exports,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "REPORTS",
        },
      },
      {
        path: "/commercial-insurance-settings",
        name: "CommercialInsuranceSettings",
        component: CommercialInsuranceSettings,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "SETTINGS",
        },
      },
      {
        path: "/commercial-insurance-facility-settings",
        name: "CommercialInsuranceFacilitySettings",
        component: CommercialInsuranceFacilitySettings,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "FACILITY SETTINGS",
        },
      },
      {
        path: "/potential-payers",
        name: "PotentialPayers",
        component: PotentialPayers,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "POTENTIAL PAYERS",
        },
      },
    ],
  },
  {
        path: "/icd-10-codes",
        name: "icd10codes",
        component: icd10Codes,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "ICD 10 CODES",
        },
      },
  {
    path: "/cases/test-reports/:case_id",
    name: "ViewTestReports",
    component: TestReports,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
  {
    path: "/signin",
    name: "signin",
    component: SignIn,
    beforeEnter: AuthMiddleware.guest,
  },
  {
    path: "/result-files/supplementary-report/:case_id/report/:report_id",
    name: "supplementaryReportView",
    component: SupplementaryReportView,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/e-requisition-view-case/:case_id",
    name: "ErequisitionView",
    component: ErequisitionView,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/e-requisition-view-order/:order_id",
    name: "ErequisitionViewOrders",
    component: ErequisitionViewOrders,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/cases/attachments-view/:case_id/:attach_id/:path",
    name: "ViewAttachments",
    component: Attachments,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/order-e-requisition/:order_id/print",
    name: "ErequisitionPrintData",
    component: PrintRequisition,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/case-e-requisition/:case_id/print",
    name: "ErequisitionCasePrintData",
    component: PrintCaseRequisition,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  // we wont include multiple barcodes in case children to avoid side navbar in case details
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
